// fr translations for the buyer payment portal. Generated to mirror
// en.ts keys 1:1; ICU placeholders ({seller}, {qty}, …) preserved verbatim.
// Brand names and financial acronyms (Caratuva, ACH, SEPA, IBAN,
// SWIFT, PIX, CNPJ, CPF, KYC, …) intentionally kept untranslated.
const fr: Record<string, string> = {
  'app.name': 'Caratuva',
  'locale.label': 'Langue',
  'invoice.title': 'Facture de {seller}',
  'invoice.amount.label': 'Montant dû',
  'invoice.lineItems.heading': 'Lignes',
  'invoice.lineItem.qty': 'Qté {qty} × {unitPrice}',
  'invoice.cta.signin': 'Se connecter pour payer',
  'invoice.cta.continue': 'Continuer vers le paiement',
  'invoice.dueDate': 'Échéance le {date}',
  'invoice.status.label': 'Statut',
  'invoice.error.notFound': 'Facture introuvable.',
  'signin.heading': 'Se connecter pour payer',
  'signin.subheading':
    'Nous vous enverrons un lien à usage unique par e-mail. Aucun mot de passe requis.',
  'signin.email.label': 'E-mail',
  'signin.email.placeholder': 'vous@entreprise.com',
  'signin.submit': 'Envoyer le lien de connexion',
  'signin.tos':
    'En continuant, vous acceptez nos <terms>Conditions d’utilisation</terms> et notre <privacy>Politique de confidentialité</privacy>.',
  'signin.success.heading': 'Consultez votre e-mail',
  'signin.success.body': 'Nous avons envoyé un lien de connexion. Il expire dans 15 minutes.',
  'signin.error.emailMismatch': 'Cet e-mail ne correspond pas au destinataire de la facture.',
  'signin.error.generic': 'Impossible d’envoyer le lien de connexion. Réessayez dans un instant.',
  'signin.session.expired': 'Votre session a expiré. Veuillez vous reconnecter.',
  'consume.loading': 'Connexion en cours…',
  'consume.error.invalid': 'Ce lien de connexion n’est pas valide.',
  'consume.error.used': 'Ce lien de connexion a déjà été utilisé. Demandez-en un nouveau.',
  'consume.error.expired': 'Ce lien de connexion a expiré. Demandez-en un nouveau.',
  'consume.error.generic': 'Impossible de vous connecter. Demandez un nouveau lien de connexion.',
  'consume.cta.requestNew': 'Demander un nouveau lien',
  'kyc.heading': 'Vérifiez votre identité',
  'kyc.subheading':
    'Effectuez une vérification d’identité ponctuelle afin que nous puissions activer l’on-ramp (entrée de fonds) pour cette facture.',
  'kyc.step.entityType': 'Type de compte',
  'kyc.step.tos': 'Conditions d’utilisation',
  'kyc.step.personal': 'Informations personnelles',
  'kyc.step.address': 'Adresse',
  'kyc.step.documents': 'Pièces d’identité',
  'kyc.step.business': 'Informations sur l’entreprise',
  'kyc.step.businessAddress': 'Adresse de l’entreprise',
  'kyc.step.owners': 'Bénéficiaires effectifs',
  'kyc.step.businessDocuments': 'Documents de l’entreprise',
  'kyc.step.review': 'Vérification',
  'kyc.step.indicator': 'Étape {current} sur {total}',
  'kyc.entityType.heading':
    'Effectuez-vous cette démarche en votre nom propre ou pour le compte d’une entreprise ?',
  'kyc.entityType.body':
    'Choisissez l’option correspondant à qui effectue le paiement. Les entreprises doivent fournir les documents de la société et les informations sur les bénéficiaires effectifs ; les particuliers n’ont besoin que de leur pièce d’identité personnelle.',
  'kyc.entityType.individual': 'Particulier',
  'kyc.entityType.individual.body':
    'Vous payez en tant que personne privée, et non pour le compte d’une entreprise.',
  'kyc.entityType.business': 'Entreprise',
  'kyc.entityType.business.body':
    'Vous payez pour le compte d’une société enregistrée ou d’une autre entité juridique.',
  'kyc.field.legalName.label': 'Raison sociale',
  'kyc.field.legalName.placeholder': 'Caratuva Inc.',
  'kyc.field.formationDate.label': 'Date de constitution',
  'kyc.field.website.label': 'Site web de l’entreprise',
  'kyc.field.website.placeholder': 'https://example.com',
  'kyc.field.businessTaxId.label': 'Identifiant fiscal de l’entreprise',
  'kyc.field.businessTaxId.placeholder': '12-3456789 / 12.345.678/0001-95',
  'kyc.field.businessTaxId.hint': 'EIN (US), CNPJ (BR) ou équivalent local.',
  'kyc.field.incorporationDocFile.label': 'Document de constitution',
  'kyc.field.incorporationDocFile.hint':
    'Statuts constitutifs, certificat de constitution ou équivalent.',
  'kyc.field.proofOfOwnershipDocFile.label': 'Justificatif de propriété',
  'kyc.field.proofOfOwnershipDocFile.hint':
    'Table de capitalisation, registre des actionnaires ou équivalent indiquant les bénéficiaires effectifs listés.',
  'kyc.owners.heading': 'Bénéficiaires effectifs',
  'kyc.owners.body':
    'Ajoutez toute personne détenant 25 % ou plus de l’entreprise, ou exerçant un contrôle significatif. Chaque bénéficiaire doit faire l’objet de la même vérification d’identité qu’un acheteur particulier.',
  'kyc.owners.add': 'Ajouter un autre bénéficiaire',
  'kyc.owners.remove': 'Supprimer',
  'kyc.owners.title': 'Bénéficiaire {index}',
  'kyc.owners.role.label': 'Rôle',
  'kyc.owners.role.beneficial_controlling':
    'Bénéficiaire effectif et personne exerçant le contrôle',
  'kyc.owners.role.beneficial_owner': 'Bénéficiaire effectif',
  'kyc.owners.role.controlling_person': 'Personne exerçant le contrôle',
  'kyc.owners.taxType.label': 'Type d’identifiant fiscal (US uniquement)',
  'kyc.owners.taxType.SSN': 'SSN',
  'kyc.owners.taxType.ITIN': 'ITIN',
  'kyc.owners.proofOfAddress.label': 'Justificatif de domicile',
  'kyc.owners.proofOfAddress.hint':
    'Document indiquant l’adresse de résidence du bénéficiaire (émis au cours des 90 derniers jours).',
  'kyc.owners.proofOfAddressType.label': 'Type de justificatif de domicile',
  'kyc.owners.proofOfAddressType.UTILITY_BILL': 'Facture de services publics',
  'kyc.owners.proofOfAddressType.BANK_STATEMENT': 'Relevé bancaire',
  'kyc.owners.proofOfAddressType.RENTAL_AGREEMENT': 'Contrat de location',
  'kyc.owners.proofOfAddressType.TAX_DOCUMENT': 'Document fiscal',
  'kyc.owners.proofOfAddressType.GOVERNMENT_CORRESPONDENCE': 'Correspondance administrative',
  'kyc.tos.heading': 'Accepter les conditions d’utilisation de notre partenaire de règlement',
  'kyc.tos.body':
    'Vous serez redirigé vers notre partenaire de règlement pour consulter et accepter les conditions d’utilisation. Après acceptation, nous vous ramènerons ici pour continuer.',
  'kyc.tos.cta': 'Continuer vers les conditions d’utilisation',
  'kyc.tos.cta.pending': 'Ouverture du partenaire de règlement…',
  'kyc.tos.accepted': 'Conditions d’utilisation acceptées.',
  'kyc.tos.required': 'Veuillez accepter les conditions d’utilisation avant de continuer.',
  'kyc.tos.error':
    'Impossible de démarrer le processus d’acceptation des conditions d’utilisation. Réessayez dans un instant.',
  'kyc.field.email.label': 'E-mail',
  'kyc.field.firstName.label': 'Prénom',
  'kyc.field.firstName.placeholder': 'Maria',
  'kyc.field.lastName.label': 'Nom',
  'kyc.field.lastName.placeholder': 'Silva',
  'kyc.field.dateOfBirth.label': 'Date de naissance',
  'kyc.field.taxId.label': 'Identifiant fiscal',
  'kyc.field.taxId.placeholder': '123-45-6789 / 123.456.789-00',
  'kyc.field.taxId.hint': 'SSN/EIN (US), CPF (BR) ou équivalent local.',
  'kyc.field.country.label': 'Pays de résidence',
  'kyc.field.country.placeholder': 'Sélectionnez un pays',
  'kyc.field.phone.label': 'Téléphone (facultatif)',
  'kyc.field.phone.placeholder': '+1 555 123 4567',
  'kyc.field.addressLine1.label': 'Adresse ligne 1',
  'kyc.field.addressLine1.placeholder': 'Rue et numéro',
  'kyc.field.addressLine2.label': 'Adresse ligne 2 (facultatif)',
  'kyc.field.addressLine2.placeholder': 'Appartement, bureau, unité',
  'kyc.field.city.label': 'Ville',
  'kyc.field.stateProvinceRegion.label': 'État / Province / Région',
  'kyc.field.postalCode.label': 'Code postal',
  'kyc.field.idDocCountry.label': 'Pays de délivrance du document',
  'kyc.field.idDocType.label': 'Type de document',
  'kyc.field.idDocType.passport': 'Passeport',
  'kyc.field.idDocType.id_card': 'Carte nationale d’identité',
  'kyc.field.idDocType.drivers': 'Permis de conduire',
  'kyc.field.idDocNumber.label': 'Numéro du document (facultatif)',
  'kyc.field.selfieFile.label': 'Selfie',
  'kyc.field.selfieFile.hint':
    'Prenez une photo nette de votre visage — sans lunettes, sans chapeau, bien éclairée. JPG ou PNG, 8 MB maximum.',
  'kyc.field.idDocFrontFile.label': 'Document — recto',
  'kyc.field.idDocFrontFile.hint':
    'Photo du recto de votre document, les quatre coins visibles. JPG ou PNG, 8 MB maximum.',
  'kyc.field.idDocBackFile.label': 'Document — verso',
  'kyc.field.idDocBackFile.hint':
    'Requis pour les cartes d’identité et les permis de conduire. JPG ou PNG, 8 MB maximum.',
  'kyc.upload.cta': 'Choisir un fichier',
  'kyc.upload.replace': 'Remplacer',
  'kyc.upload.uploading': 'Téléversement…',
  'kyc.upload.uploaded': 'Téléversé',
  'kyc.upload.error': 'Échec du téléversement. Essayez un autre fichier.',
  'kyc.upload.unsupported': 'Utilisez un fichier JPG, PNG ou WebP de moins de 8 MB.',
  'kyc.upload.preview': 'Aperçu',
  'kyc.error.required': 'Ce champ est obligatoire.',
  'kyc.error.email': 'Saisissez une adresse e-mail valide.',
  'kyc.error.country': 'Utilisez le code ISO-3166-1 alpha-2 (par ex. US, BR, FR).',
  'kyc.error.dateOfBirth': 'Saisissez une date de naissance valide.',
  'kyc.error.minor': 'Vous devez avoir 18 ans ou plus.',
  'kyc.error.generic':
    'Impossible de démarrer votre vérification d’identité. Réessayez dans un instant.',
  'kyc.review.heading': 'Vérification d’identité envoyée',
  'kyc.review.body':
    'Votre vérification d’identité est en cours d’examen. Nous vous enverrons un e-mail une fois qu’elle aura été traitée.',
  'kyc.review.cta': 'Voir le statut du paiement',
  'kyc.review.summary.heading': 'Vérifiez vos informations',
  'kyc.review.summary.body':
    'Prenez un moment pour confirmer que tout est correct. Une fois envoyée, vous ne pouvez plus modifier une soumission KYC — il vous faudrait en démarrer une nouvelle.',
  'kyc.submit': 'Envoyer la vérification d’identité',
  'kyc.submit.pending': 'Envoi en cours…',
  'kyc.next': 'Continuer',
  'kyc.back': 'Retour',
  'kyc.status.label': 'Statut',
  'kyc.status.verifying': 'En cours d’examen',
  'kyc.status.approved': 'Approuvé',
  'kyc.status.rejected': 'Rejeté',
  'kyc.status.notStarted': 'Non commencé',
  'kyc.hosted.cta': 'Continuer vers le fournisseur d’identité',
  'onramp.heading': 'Choisissez votre mode de paiement',
  'onramp.subheading':
    'Nous verrouillons une cotation de change pendant 10 minutes dès que vous sélectionnez un mode.',
  'onramp.method.ach': 'ACH (virement bancaire US)',
  'onramp.method.wire': 'Virement (wire)',
  'onramp.method.sepa': 'SEPA (virement bancaire UE)',
  'onramp.method.card': 'Carte',
  'onramp.method.label': 'Mode de financement',
  'onramp.targetCurrency.label': 'Devise que vous allez envoyer',
  'onramp.targetCurrency.helper':
    'Nous convertissons au taux verrouillé à la réception des fonds. Faites correspondre cette devise au compte depuis lequel vous effectuez l’envoi.',
  'onramp.quote.locked': 'Cotation verrouillée. Expire le {expires}.',
  'onramp.quote.expired': 'La cotation a expiré. Actualisez pour en verrouiller une nouvelle.',
  'onramp.quote.refresh': 'Actualiser la cotation',
  'onramp.cta.lockQuote': 'Verrouiller la cotation de change',
  'onramp.cta.confirm': 'Confirmer et obtenir les instructions',
  'onramp.cta.confirm.pending': 'Envoi en cours…',
  'onramp.error.generic': 'Impossible de démarrer l’on-ramp. Réessayez dans un instant.',
  'onramp.instructions.heading': 'Envoyez votre paiement',
  'onramp.instructions.subheading':
    'Ce compte est propre à votre facture — envoyez le montant exact et nous rapprochons votre virement automatiquement.',
  'onramp.instructions.bank': 'Banque',
  'onramp.instructions.accountName': 'Nom du compte',
  'onramp.instructions.accountNumber': 'Numéro de compte',
  'onramp.instructions.routing': 'Numéro de routage',
  'onramp.instructions.iban': 'IBAN',
  'onramp.instructions.swift': 'SWIFT / BIC',
  'onramp.instructions.reference': 'Code de référence',
  'onramp.instructions.memo': 'Libellé (memo)',
  'onramp.instructions.copy': 'Copier',
  'onramp.instructions.copied': 'Copié',
  'onramp.instructions.continue': 'Suivre ce paiement',
  'onramp.instructions.empty':
    'Aucune instruction bancaire renvoyée pour le moment. Nous vous les enverrons par e-mail dès qu’elles seront prêtes.',
  'tracking.heading': 'Suivi du paiement',
  'tracking.placeholder':
    'Les écrans KYC, mode de financement et on-ramp (entrée de fonds) arriveront dans des PR ultérieures.',
  'tracking.cta.back': 'Retour à la facture',
  'tracking.cta.startOnRamp': 'Continuer vers le paiement',
  'tracking.refreshing': 'Recherche de mises à jour…',
  'tracking.timeline.heading': 'Progression',
  'tracking.step.invoice': 'Facture reçue',
  'tracking.step.kyc': 'Vérification d’identité terminée',
  'tracking.step.onramp': 'On-ramp (entrée de fonds) lancé',
  'tracking.step.fiat': 'Fonds reçus',
  'tracking.step.offramp': 'Off-ramp (sortie de fonds) lancé',
  'tracking.step.settled': 'Réglé en BRL',
  'tracking.alert.kycRejected.heading': 'Vérification d’identité rejetée',
  'tracking.alert.kycRejected.body':
    'Votre vérification d’identité n’a pas pu être approuvée. Soumettez-la à nouveau avec des informations mises à jour.',
  'tracking.alert.kycRejected.cta': 'Soumettre à nouveau la vérification d’identité',
  'tracking.alert.kycPending.heading': 'Vérification d’identité en cours d’examen',
  'tracking.alert.kycPending.body':
    'Nous attendons le prestataire de vérification. Nous vous enverrons un e-mail dès qu’elle sera terminée.',
  'tracking.alert.underpayment.heading': 'Paiement insuffisant détecté',
  'tracking.alert.underpayment.body':
    'Le montant que nous avons reçu est inférieur à celui de la facture. Contactez le support pour régulariser.',
  'tracking.alert.contactSupport': 'Contacter le support',
  'tracking.alert.expired.heading': 'Facture expirée',
  'tracking.alert.expired.body':
    'Cette facture a expiré. Demandez au vendeur d’en émettre une nouvelle.',
  'tracking.alert.cancelled.heading': 'Facture annulée',
  'tracking.alert.cancelled.body': 'Le vendeur a annulé cette facture.',
  'common.loading': 'Chargement…',
  'common.retry': 'Réessayer',
};
export default fr;
